import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { backgroundLayers } from "config/baseLayers";
import {
  useBackgroundLayerParams,
  useSelectedBackgroundLayer,
} from "hooks/mapHooks";
import { ChangeEvent } from "react";

export function BackgroundLayerSelect() {
  const availableBackgroundLayers = backgroundLayers;
  const selectedBackgroundLayer = useSelectedBackgroundLayer();
  const { updateBackgroundLayerParam } = useBackgroundLayerParams();

  function onChange(event: ChangeEvent<HTMLInputElement>) {
    updateBackgroundLayerParam(+(event.target.value || ""));
  }

  return (
    <RadioGroup
      value={selectedBackgroundLayer.id}
      name="backgroundLayers"
      onChange={onChange}
    >
      {availableBackgroundLayers.map((backgroundLayer) => (
        <FormControlLabel
          key={`${backgroundLayer.id}`}
          value={backgroundLayer.id}
          control={<Radio />}
          label={backgroundLayer.name}
        />
      ))}
    </RadioGroup>
  );
}
